import {useMemo} from 'react';

import {useAnnotationModeStore} from './AnnotationModeStore';
import type {QuestionNote} from './annotationNotes';
import {collectQuestionNotes} from './annotationNotes';

/**
 * The notes on the active question, in reading order. The selector returns the
 * raw store map so the snapshot stays cached; the allocation happens in the memo.
 */
export function useQuestionNotes(questionId: string | undefined): QuestionNote[] {
  const annotationsByRegionId = useAnnotationModeStore((state) => state.annotationsByRegionId);

  return useMemo(
    () => collectQuestionNotes(annotationsByRegionId, questionId),
    [annotationsByRegionId, questionId]
  );
}
